  $( document ).ready(function() {
  $(window).scroll(function () {
  
    if ($(".site_review_section").length) {
      var section_id = $('.site_review_section').offset().top;
      var window_height = $(window).height() / 2;
      var window_scroll = $(this).scrollTop() + $(".shopify-section-group-header-group").height() + window_height;
      if (window_scroll >= section_id) {
          console.log("aaaaaaa////////////////////")
        if ($(".site_review_section").hasClass("active_count")) {
          $.fn.jQuerySimpleCounter = function (options) {
            var settings = $.extend({
              start: 0,
              end: 100,
              easing: 'swing',
              duration: 400,
              complete: ''
            }, options);
            var thisElement = $(this);
            $({ count: settings.start }).animate({ count: settings.end }, {
              duration: settings.duration,
              easing: settings.easing,
              step: function () {
                var mathCount = Math.ceil(this.count);
                thisElement.text(mathCount);
              },
              complete: settings.complete
            });
          };
          if ($('.total_review_counter').length) {
            var count_one = parseInt($('.total_review_counter').attr("data_counter"));
            $('.total_review_counter span').jQuerySimpleCounter({ end: count_one, duration: 3000 });
          }
          if ($('.five_star_review').length) {
            var count_one = parseInt($('.five_star_review').attr("data_five_star"));
            $('.five_star_review').jQuerySimpleCounter({ end: count_one, duration: 3000 });
          }
          if ($('.four_star_review').length) {
            var count_one = parseInt($('.four_star_review').attr("data_four_star"));
            $('.four_star_review').jQuerySimpleCounter({ end: count_one, duration: 3000 });
          }
          $(".site_review_section").removeClass("active_count");
        }
      }
    }
  });
})